import useLocalStorage from '@helpers/hooks/useLocalStorage'

type UseFilterCatetory<T> = [T, (value: T) => void]

export function useFilterCategory(
  isMultiCollection: boolean
): UseFilterCatetory<string> {
  const [filterCategory, setFilterCategory] = useLocalStorage(
    'spoke_filterCategory',
    'all'
  )
  const [filterSubCategory, setFilterSubCategory] = useLocalStorage(
    'spoke_filterSubCategory',
    'all'
  )

  return isMultiCollection
    ? [filterCategory, setFilterCategory]
    : [filterSubCategory, setFilterSubCategory]
}
